var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 64,
    fill: "url(#paint0_linear_618_5785)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6364 64C11.6364 92.9196 35.0804 116.364 64 116.364C92.9196 116.364 116.364 92.9196 116.364 64C116.364 35.0804 92.9196 11.6364 64 11.6364C35.0804 11.6364 11.6364 35.0804 11.6364 64ZM64 0C28.6538 0 0 28.6538 0 64C0 99.3462 28.6538 128 64 128C99.3462 128 128 99.3462 128 64C128 28.6538 99.3462 0 64 0Z",
    fill: "url(#paint1_linear_618_5785)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1818 40.7273C58.1818 37.514 55.5769 34.9091 52.3636 34.9091C49.1503 34.9091 46.5455 37.514 46.5455 40.7273V87.2727C46.5455 90.486 49.1503 93.0909 52.3636 93.0909C55.5769 93.0909 58.1818 90.486 58.1818 87.2727V40.7273Z",
    fill: "url(#paint2_linear_618_5785)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4545 40.7273C81.4545 37.514 78.8497 34.9091 75.6364 34.9091C72.4231 34.9091 69.8182 37.514 69.8182 40.7273V87.2727C69.8182 90.486 72.4231 93.0909 75.6364 93.0909C78.8497 93.0909 81.4545 90.486 81.4545 87.2727V40.7273Z",
    fill: "url(#paint3_linear_618_5785)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_618_5785",
    x1: 64,
    y1: 0,
    x2: 64,
    y2: 128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9238FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4800B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_618_5785",
    x1: 64,
    y1: 0,
    x2: 64,
    y2: 128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_618_5785",
    x1: 64,
    y1: 0,
    x2: 64,
    y2: 128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_618_5785",
    x1: 64,
    y1: 0,
    x2: 64,
    y2: 128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.153863e7249bc3e6ce87a7f5503f4084.svg";
export { ForwardRef as ReactComponent };